import React, { createContext, useContext, useState, useEffect } from "react";
import axios from 'axios';
import { useAuthContext } from './AuthContext.tsx';
import { useNavigate } from "react-router-dom";

const DevicesContext = createContext(null);

export const useDevicesContext = () => {
    const context = useContext(DevicesContext)
    return context;
}
 
export const DevicesContextProvider = ({ children }) => {
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const storedToken = localStorage.getItem('token');

    const { auth } = useAuthContext(); 

    useEffect(() => {
        const fetchDevicesData = async () => {
           if(!auth){
            navigate("/login");
            return
           }
           try {
            setIsLoading(true);
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/cust-portal/customer/stores`, {
                headers: {
                    Authorization: `Bearer ${storedToken}`,
                },
            })
            //console.log("DEVICES DATA", response?.data)
            setData(response?.data)
            setIsLoading(false)
        } catch (error) {
            //console.error('Error fetching devices data', error);
            setIsLoading(false);        
        }
        }
        fetchDevicesData();
    }, [auth])

    return (
        <DevicesContext.Provider value={{ data, setData, isLoading, setIsLoading }}>
            {children}
        </DevicesContext.Provider>
    )  
}  